export const getUserData = (state) => {
    return state.userData
}
export const getUserInfo = (state) => {
    return state.userInfo
}
export const getToken = (state) => {
    return state.jwt
}
export const getEnv = (state) => {
    return state.environment
}